export default function Image({ src }) {
  return <img src={src} alt="" />;
}
